import React,{useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import swal from 'sweetalert';
import { isEmpty } from 'components/Login/validator';
import './MultiFileUpload.scss'


const MultiFileUpload = ({ multiUploadFiles, setMultiUploadFiles, docUrl,editHandler , setDocUrl,setEditProp,setDocEdit, buildInputVal}) => {
   
    const [disabled, setDisabled] = useState(true)
    const uploadHandler = (event) => {
        const multifile = event.target.files[0];
        editHandler("MultiFileUpload")
        const allowedfileExtensions = ["docx"];
        const span = document.createElement("span");
        setEditProp(true)
        setDocEdit(1)
        if(multifile){
            span.innerHTML = `The specified ${multifile.type !== "" ? 'file' : 'directory'} <code>${multifile.name}</code> could not be uploaded`;
            let fileExtension = multifile.name.match(/\.([^\.]+)$/);
            if (multifile.name.match(/\.([^\.]+)$/) !== null && allowedfileExtensions.includes(fileExtension[1])) {
            if(docUrl){
                setDocUrl([multifile]) 
            }
            else{
                setDocUrl([multifile]) 
            }
            if(multiUploadFiles){
                setMultiUploadFiles([multifile])
            }
            else{
                setMultiUploadFiles([multifile]) 
            }
            } else {
                swal({
                    title: 'Only files with the following extensions are allowed: docx',
                    content: span,
                    icon: "warning",
                });
            }
        }
        
        event.target.value = '';
    }

    useEffect(() => {
        if(!isEmpty(buildInputVal)){
            if(buildInputVal.platform.value !== null && buildInputVal.platform.value !== "Please Select"){
                setDisabled(false)
            }else {
                setDisabled(true)
            }
        }
    },[buildInputVal])

    return (
        <>
            <div className={`multiFile-card ${disabled && "multifile-disabled"}`}>

                <div className="multifile-inputs">
                    <input type="file" onChange={uploadHandler} disabled={disabled} className={`${disabled && "multifile-disabled"}`} />
                    <button>
                        <i>
                            <FontAwesomeIcon icon={faPlus} />
                        </i>
                        Upload
                    </button>
                </div>
                <p className="multi-main">Click or drag files to upload</p>
                <p className="multi-info">Supported file types: .docx</p>

            </div>
        </>
    )
}

export default MultiFileUpload;